import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-route-loading-bar',
    standalone: true,
    imports: [CommonModule],
    template: `
    <div *ngIf="visible()" class="fixed top-0 left-0 right-0 z-[9999] h-1 overflow-hidden pointer-events-none">
      <div class="route-loading-bar h-full w-1/3 bg-rose-500"></div>
    </div>
    `,
    styles: [`
    .route-loading-bar {
      animation: routeLoading 1s ease-in-out infinite;
    }
    @keyframes routeLoading {
      0% { transform: translateX(-100%); }
      100% { transform: translateX(400%); }
    }
    `]
})
export class RouteLoadingBarComponent {
    private router = inject(Router);
    visible = signal(false);

    constructor() {
        this.router.events.pipe(takeUntilDestroyed()).subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.visible.set(true);
            }
            if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
                this.visible.set(false);
            }
        });
    }
}
